import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-924cc926"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "RenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "题目中将给出一个平面图形，需要从选项中选出经平面旋转后与题目图形一致的图形选项。", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_NineGrid = _resolveComponent("NineGrid");
  const _component_NineGridColor = _resolveComponent("NineGridColor");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [$props.subject === 'NineGrid' ? (_openBlock(), _createBlock(_component_NineGrid, {
      items: $props.data.question,
      key: $props.data.question.flat().join('-')
    }, null, 8, ["items"])) : _createCommentVNode("", true), $props.subject === 'NineGridColor' ? (_openBlock(), _createBlock(_component_NineGridColor, {
      items: $props.data.question,
      key: $props.data.question.flat().join('-')
    }, null, 8, ["items"])) : _createCommentVNode("", true)]),
    _: 1
  }), (_openBlock(), _createBlock(_component_el_row, {
    class: "bothCenter mt64 mb32",
    key: `moss_q_${$props.data.questionIndex}`
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.answers, (answer, index) => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 6,
        class: "flex flex-col bothCenter",
        key: index
      }, {
        default: _withCtx(() => [$props.subject === 'NineGrid' ? (_openBlock(), _createBlock(_component_NineGrid, {
          key: 0,
          items: answer
        }, null, 8, ["items"])) : _createCommentVNode("", true), $props.subject === 'NineGridColor' ? (_openBlock(), _createBlock(_component_NineGridColor, {
          key: 1,
          items: answer
        }, null, 8, ["items"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          disabled: $props.reviewMode,
          type: $data.select === String.fromCharCode(65 + index) ? 'primary' : '',
          style: {
            "margin-top": "10px"
          },
          onClick: $event => $options.onChoosed(String.fromCharCode(65 + index))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(String.fromCharCode(65 + index)), 1)]),
          _: 2
        }, 1032, ["disabled", "type", "onClick"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}